import { combineReducers } from "redux";
import { campaignsListReducer } from "../../Views/GLU/GLUCampaignsList/campainsListReducer";
import { campaignStatusReducer } from "../../Views/GLU/GLUCampaignStatus/campainStatusReducer";
import { GLUViewReducer } from "../../Views/GLU/viewReducer";

const GLUReducers = combineReducers({
  campaignsList: campaignsListReducer,
  campaignStatus: campaignStatusReducer,
  gluSwitchView: GLUViewReducer
});

export default GLUReducers;
